import React from 'react';
import LandingDemoConversation from './LandingDemoConversation';

const BE_THE_CLIENT_TURNS = [
  {
    speaker: 'clinician',
    text: 'You have been carrying this around for a while, and part of you is getting tired of how much space it takes up.',
  },
  {
    speaker: 'client',
    text: "Yeah, that's true. I keep telling myself it's manageable, but it takes more effort than I want to admit.",
  },
  {
    speaker: 'clinician',
    text: 'When you imagine things going a little better, what feels most important to be different?',
  },
  {
    speaker: 'client',
    text: 'I think I would want to feel more in control, instead of always reacting once things have already piled up.',
  },
];

export default function BeTheClientModalDemo() {
  return (
    <div className="anonymous-landing__demo anonymous-landing__demo--conversation-only">
      <LandingDemoConversation turns={BE_THE_CLIENT_TURNS} visualMode="reverse" />
    </div>
  );
}
